import { render } from "./LegalNotice.vue?vue&type=template&id=e32ed578&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=e32ed578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e32ed578"]])

export default __exports__